import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import DocumentConstants from 'constants/documents';
import i18n from 'i18n-js';

function VersionStatus(props) {
  const { status, fontSize, defaultMessage } = props;
  const statusColor =
    typeof status === 'string'
      ? (theme) => theme.palette.documents[status.toLowerCase()]
      : undefined;

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        whiteSpace: 'nowrap',
        fontSize,
        lineHeight: 1,
      }}
    >
      {status !== 'NONE' && (
        <Box
          component="span"
          sx={{
            height: 8,
            width: 8,
            marginRight: 1,
            borderRadius: 16,
            display: 'inline-block',
            backgroundColor: statusColor,
          }}
        />
      )}
      <span>{i18n.t(`documents.${String(status).toLocaleLowerCase()}`) || defaultMessage}</span>
    </Box>
  );
}

VersionStatus.propTypes = {
  fontSize: PropTypes.number,
  /**
   * Current version status
   */
  status: PropTypes.oneOf(DocumentConstants.statuses),
  defaultMessage: PropTypes.string,
};

VersionStatus.defaultProps = {
  fontSize: 14,
  status: undefined,
  defaultMessage: '',
};

export default VersionStatus;
